/**
 * Created by pmnia on 02/03/15.
 */
/**
 * Created by pmnia on 02/03/15.
 */
(function (app) {
    'use strict';

    app.factory('calendarServices', calendarServices);
    /*@ngInject*/
    function calendarServices(queryservice, $q){
        return  {
            getProfile:getProfile,
            getData:getData
        };

        function getProfile(cId, tId) {
            if(cId){
                var fctArgsJson= {cId:cId};
                if(tId){
                    fctArgsJson.tId = tId;
                }

                var fctName= "obtAdvHelper.getTherapistsInfo"; //
                return queryservice.callServer(fctName,fctArgsJson)
                    .then(findCalendarProfile);
            }
        }

        function findCalendarProfile(data){
            if(data && data.error === 0){
                return data[0].calendar;
            }else{
                return data;
            }
        }

        function getData(start, end, cId, tId, filters) {
            if(cId){
                var fctArgsJson = filters || {};
                fctArgsJson.start = start;
                fctArgsJson.end = end;
                fctArgsJson.cId = cId;

                if(tId){
                    fctArgsJson.tId = tId;
                }
                var fctName= "obtCalHelper.getCalendarData";
                return queryservice.callServer(fctName,fctArgsJson)
                    .then(function (result){
                        return result &&  result.data ? result.data : result;
                    });
            }else{
                return $q.when([]);
            }
        }
    }
})(angular.module('app.data'));



/*****************
 ** WEBPACK FOOTER
 ** ./app/data/calendar.services.js
 ** module id = 163
 ** module chunks = 0
 **/